module.exports = __webpack_public_path__ + "static/media/messages-ephemeres.111c3744.png";